/**
 * Enum loại phân bổ chi từ nguồn bổ sung cấp trên
 */
export default {
  /**
   * None
   */
  None: 0,
  /**
   * CĐT
   */
  Invest: 1,
  /**
   * CTX
   */
  Regular: 2,
  /**
   * CTMT
   */
  Project: 3,
  /**
   * Nguồn kinh phí
   */
  Source: 4,
};
